import {
    Component, Mixins, Vue,
} from 'vue-property-decorator';
import Hybrid from '@components/shared/mixins/hybrid';
import Classes from '@components/shared/mixins/classes';
import config from '@components/shared/config';
import VuePlyr from 'vue-plyr';
import Props from './props';
import 'vue-plyr/dist/vue-plyr.css';

Vue.use(VuePlyr);

/**
 * @name Player
 */
@Component({})
class YPlayer extends Mixins(Hybrid, Props, Classes) {
    /**
     * Video file extensions
     */
    defaultVideoExtensions: Array<any> = ['webm', 'mpeg', 'm4v', 'm4p', 'mp4', 'wmv', 'avi', 'webm', 'mov', 'flv', ...this.getValue('videoExtensions')];

    /**
     * Audio file extensions
     */
    defaultAudioExtensions: Array<any> = ['mp3', 'aac', 'flac', 'alac', 'wav', ...this.getValue('audioExtensions')];

    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = [];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.player);

    /**
     * Create Common Props for the player.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            if (this.element && this.element[item]) {
                commonProps[item] = this.element[item];
            } else {
                commonProps[item] = this[item];
            }
        });
        return commonProps;
    }

    /**
     * Create classes array for the player.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Player', this.commonProps, this.baseClass || config.prefix.player));
        return cls;
    }

    /**
     * Retrun audio source base on url to avoiding CORS error
     * 
     * @returns {string} - source link
     */
    get getAudioSource(): string {
        const find = this.getValue('src').match(/\/files\//) ? this.getValue('src').search(/\/files\//) : false;

        if (find) {
            return `${window.location.origin}${this.getValue('src').substring(find, this.getValue('src').length)}`;
        }

        return this.getValue('src');
    }

    /**
     * Next shift audio player
     */
    nextShift() {
        const audio: any = this.$refs.plyrAudioTag;
        audio.currentTime += 10;
    }

    /**
     * Back shift audio player
     */
    backShift() {
        const audio: any = this.$refs.plyrAudioTag;
        if (audio.currentTime - 10 < 0) {
            audio.currentTime = 0;
        } else {
            audio.currentTime -= 10;
        }
    }

    /**
     * Return media type
     * 
     * @param {string} src
     * @returns {object}
     */
    getType(src: string = this.getValue('src')): object {
        const extension = (/[.]/.exec(src)) ? /[^.]+$/.exec(src)[0] : undefined;
        if (this.defaultVideoExtensions.includes(extension)) {
            return {
                type: this.getValue('type') || 'video',
                extension,
            };
        }

        if (this.defaultAudioExtensions.includes(extension)) {
            return {
                type: this.getValue('type') || 'audio',
                extension,
            };
        }

        return {
            type: this.getValue('type'),
            extension,
        };
    }
}

export default YPlayer;
